"use client";

import { extractYouTubeId } from "@/lib/blog";
import YouTubePlayer from "@/components/video/youtube-player";

export function BlogHeroVideo({
  youtubeUrl,
  title,
  posterUrl,
}: {
  youtubeUrl: string;
  title?: string;
  posterUrl?: string;
  posterAlt?: string;
}) {
  const id = extractYouTubeId(youtubeUrl);
  if (!id) return null;

  return (
    <div className="relative size-full">
      <YouTubePlayer videoId={id} title={title} posterSrc={posterUrl} />
    </div>
  );
}
